module.exports = __webpack_public_path__ + "static/media/ic_refresh_cw.985086bd.svg";